export default "__VITE_ASSET__ClC7r_vO__"